import React from 'react';
import {Trans} from "@lingui/macro";
import {CardElement} from '@stripe/react-stripe-js';
import Styled from './CardSection.style';

const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            color: "#32325d",
            fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
};

function CardSection() {
    return (
        <Styled>
            <label>
                <h3 className="title"><Trans>Billing Information</Trans></h3>
                <CardElement options={CARD_ELEMENT_OPTIONS} />
            </label>
            <div className="stripe-logo">
                <a href="https://stripe.com" target="_blank" rel="noopener noreferrer">
                    <img src="/img/powered_by_stripe.png" alt="" />
                </a>
            </div>
        </Styled>
    );
}
export default CardSection;
